import DisplayPropertiesPicker from '../widgets/DisplayPropertiesPicker';

const displaySchema = {
  type: 'object',
  properties: {
    componentIsActive: {
      type: ['boolean', 'null'],
      title: 'Section visibility',
      default: null,
      oneOf: [
        {
          type: 'null',
          enum: [null],
          title: 'Always visible',
        },
        {
          type: 'boolean',
          enum: [true],
          title: 'Only when active component selected',
        },
        {
          type: 'boolean',
          enum: [false],
          title: 'Only when no active component selected',
        },
      ],
    },
  },
};

const displayUiSchema = {
  componentIsActive: {
    'ui:widget': DisplayPropertiesPicker,
  },
};

export { displaySchema, displayUiSchema };
